// extracted by mini-css-extract-plugin
export default {"homologacaoBotoes":"ArquivarSolicitacao_homologacaoBotoes__DxYxt","motivoArquivamento":"ArquivarSolicitacao_motivoArquivamento__lGd-i"};